// Import required types
import { Language, MtLanguage, Xl8Language } from "gen/clients";
import { SelectOption } from "@mui/base";

function isLanguage(obj: Language | MtLanguage | Xl8Language): obj is Language {
  return (obj as Language).id !== undefined;
}

function isXl8Language(obj: Language | MtLanguage | Xl8Language): obj is Xl8Language {
  return (obj as Xl8Language).xl8code !== undefined && (obj as Language).id === undefined;
}

function createSelectOptionWithLanguage(language: Language): { label: string; value: string } {
  return {
    label: `${language.name} [${language.id}]`,
    value: `${language.id}`
  };
}

function createSelectOptionWithMtLanguage(language: MtLanguage): { label: string; value: string } {
  return {
    label: `${language.name} [${language.code}]`,
    value: language.code
  };
}

function createSelectOptionWithXl8Language(language: Xl8Language): { label: string; value: string } {
  return {
    label: language.name ? `${language.name} [${language.xl8code}]` : `${language.xl8code}`,
    value: language.xl8code
  };
}

export function createSelectOptionWithAnyLanguage(language: Language | MtLanguage | Xl8Language): {
  label: string;
  value: string;
} {
  if (isLanguage(language)) {
    return createSelectOptionWithLanguage(language);
  }
  if (isXl8Language(language)) {
    return createSelectOptionWithXl8Language(language);
  }
  return createSelectOptionWithMtLanguage(language);
}

export function getLanguageOptions(languages: (Language | MtLanguage | Xl8Language)[]): SelectOption<string>[] {
  return languages
    .map(language => createSelectOptionWithAnyLanguage(language))
    .sort((o1, o2) => o1.label.localeCompare(o2.label));
}
